import React from 'react'
import { Carousel } from '.'

const GalleryPopup = ({onClose, isMobile, images, initialSlide}) => {
  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
      {/* pt-8 pb-5 lg:pt-20 lg:pb-20 px-5 lg:px-24 bg-white*/}
        <div className="lg:w-10/12 mx-auto rounded">
          <Carousel images={images} initialSlide={initialSlide} isMobile={isMobile}/>
        </div>
      </div>
    </div>
  )
}

export { GalleryPopup }